import { 
    SERVICE_ADD,
    SERVICE_REMOVE,
    SERVICE_EDIT,
    IServiceState
} from "./types";
import { ThunkDispatch } from "redux-thunk";
import ServiceAPI from "../../api/service";

// ---- ADD ---- //

export type AddServiceType = (name: string, type: string, params: object) => Promise<IServiceState>;
export const addService = (name: string, type: string, params: object) => (dispatch: ThunkDispatch<{},{},any>) =>
{
    let action = (state: IServiceState) =>
    {
        dispatch({
            type: SERVICE_ADD,
            serviceState: state
        });
        return new Promise<IServiceState>(resolve=>resolve(state));
    };
    
    return ServiceAPI.addService(type, name, params).then(action);
}

// ---- EDIT ---- //

export type EditServiceType = (id: string, name: string, params: object) => Promise<IServiceState>;
export const editService = (id: string, name: string, params: object) => (dispatch: ThunkDispatch<{},{},any>) =>
{
    let action = (state: IServiceState) =>
    {
        dispatch({
            type: SERVICE_EDIT,
            serviceState: state
        });
        return new Promise<IServiceState>(resolve=>resolve(state));
    };

    return ServiceAPI.editService(id, name, params).then(action);
}

// --- REMOVE --- //

export type RemoveServiceType = (id: string) => Promise<IServiceState>;
export const removeService = (id: string) => (dispatch: ThunkDispatch<{},{},any>) =>
{
    let action = (id: string) =>
    {
        dispatch({
            type: SERVICE_REMOVE,
            id: id
        });
        return new Promise<IServiceState>(resolve=>resolve({id: id} as IServiceState));
    };

    return ServiceAPI.removeService(id).then(action);
}

// --------------- //